import { StoreItemSearch } from '@givebacks/api/store';
import { createSafeContext } from 'core/Utils';

type StoreSearchContextValue = {
  storeSearchObject: StoreItemSearch | undefined;
  setStoreSearchObject: (value: StoreItemSearch) => void;
};

export const [StoreSearchProvider, useStoreSearchContext] =
  createSafeContext<StoreSearchContextValue>('Store component was not found in tree');
